<template>
    <div class="page">
        <section class="q10__jumbotron">
            <image-with-descriptions
                class="mb-8 mt-0"
                :options="{
                    image:
                        'pages/' +
                        currentPage.slug +
                        '/' +
                        currentPage.images.imageJumbotron.src,
                    descriptions: [
                        {
                            text: currentPage.images.imageJumbotron.edf,
                            position: 'bottom-right', // top/bottom-left/right
                            orientation: 'horizontal', // vertical, horizontal
                        },
                    ],
                }"
            />
        </section>
        <div class="container px-11 2xl:px-3 mb-14 m-auto">
            <title-s-chapter
                :options="{
                    from: 'from-resolution_blue',
                    to: 'to-dodger_blue',
                }"
            >
                <h1 v-html="currentPage.content.mainTitle.text"></h1>
            </title-s-chapter>
            <p
                class="font-bold text-tundora text-xl mb-5"
                v-html="currentPage.content.firstSubTitle.text"
            ></p>

            <div class="container-components mb-4 lg:mb-8">
                <div class="card mt-0">
                    <TitleParagraph
                        :options="{
                            from: 'from-resolution_blue',
                            to: 'to-dodger_blue',
                        }"
                    >
                        <p
                            class="text-xl lg:text-2xl 2xl:text-4xl"
                            v-html="currentPage.content.secondSubTitle.text"
                        ></p>
                    </TitleParagraph>
                    <paragraph
                        :options="{
                            color: 'text-nandor',
                        }"
                    >
                        <span
                            class="font-bold text-lg"
                            v-html="currentPage.content.firstParagraph.text"
                        >
                        </span>
                    </paragraph>
                </div>

                <div class="card break-inside-avoid">
                    <TitleParagraph
                        :options="{
                            from: 'from-resolution_blue',
                            to: 'to-dodger_blue',
                        }"
                    >
                        <Triangles
                            :options="{
                                colors: ['#00357f', '#0b4f9c', '#0d94ff'],
                                direction: 'top',
                            }"
                        />
                        <span
                            v-html="currentPage.content.firstTitle.text"
                        ></span>
                    </TitleParagraph>
                    <paragraph
                        :options="{
                            color: 'text-nandor',
                        }"
                    >
                        <span v-html="currentPage.content.secondParagraph.text">
                        </span>
                    </paragraph>
                </div>

                <div class="card">
                    <!-- <div class="break-inside-avoid"> -->
                        <div class="relative w-full h-full">
                            <image-with-descriptions
                                :options="{
                                    image:
                                        'pages/' +
                                        currentPage.slug +
                                        '/' +
                                        currentPage.images.image1.src,
                                    descriptions: [
                                        {
                                            text: currentPage.images.image1
                                                .edf,
                                            position: 'bottom-right', // top/bottom-left/right
                                            orientation: 'horizontal', // vertical, horizontal
                                        },
                                    ],
                                }"
                            />
                        </div>
                        <div class="break-inside-avoid">
                        <TitleParagraph
                            :options="{
                                from: 'from-resolution_blue',
                                to: 'to-dodger_blue',
                            }"
                        >
                            <Triangles
                                :options="{
                                    colors: ['#00357f', '#0b4f9c', '#0d94ff'],
                                    direction: 'Desktop_left_Tablet_and_Mobile_top',
                                }"
                            />
                            <span
                                v-html="currentPage.content.secondTitle.text"
                            ></span>
                        </TitleParagraph>
                    <!-- </div> -->

                    <paragraph
                        :options="{
                            color: 'text-nandor',
                        }"
                    >
                        <span v-html="currentPage.content.thirdParagraph.text">
                        </span>
                        <!-- <Dots
                            :options="{
                                colors: ['#00357f', '#0b4f9c', '#0d94ff'],
                            }"
                        /> -->
                    </paragraph>
                    </div>
                </div>
            </div>

            <div class="relative mb-4 lg:mb-8">
                <hotspot-richmedia
                    :options="{
                        icon: 'diaporama',
                        collection: getRichmediaByCollection(
                            currentPage,
                            'Chantier La Coche Pelton 2015-2019'
                        ),
                    }"
                    class="top-2 right-2"
                />
                <image-with-descriptions
                    :options="{
                        image:
                            'pages/' +
                            currentPage.slug +
                            '/' +
                            currentPage.images.image2.src,
                        descriptions: [
                            {
                                text: currentPage.images.image2.edf,
                                position: 'bottom-right', // top/bottom-left/right
                                orientation: 'horizontal', // vertical, horizontal
                            },
                        ],
                    }"
                />
            </div>
            <div class="container-components">
                <div class="card break-inside-avoid">
                    <TitleParagraph
                        :options="{
                            from: 'from-resolution_blue',
                            to: 'to-dodger_blue',
                        }"
                    >
                        <Triangles
                            :options="{
                                colors: ['#00357f', '#0b4f9c', '#0d94ff'],
                                direction: 'top',
                            }"
                        />
                        <span
                            v-html="currentPage.content.thirdSubTitle.text"
                        ></span>
                    </TitleParagraph>
                    <paragraph
                        :options="{
                            color: 'text-nandor',
                        }"
                    >
                        <span v-html="currentPage.content.fourthParagraph.text">
                        </span>
                    </paragraph>
                   
                </div>
                <div class="card">
                    <TitleParagraph
                        :options="{
                            from: 'from-resolution_blue',
                            to: 'to-dodger_blue',
                        }"
                    >
                        <span
                            v-html="currentPage.content.fifthSubTitle.text"
                        ></span>
                    </TitleParagraph>
                    <paragraph
                        :options="{
                            color: 'text-nandor',
                        }"
                    >
                        <span v-html="currentPage.content.sixthParagraph.text">
                        </span>
                    </paragraph>
                </div>

                <div class="card break-inside-avoid">
                    <TitleParagraph
                        :options="{
                            from: 'from-resolution_blue',
                            to: 'to-dodger_blue',
                        }"
                    >
                        <span
                            v-html="currentPage.content.fourthSubTitle.text"
                        ></span>
                    </TitleParagraph>
                    <paragraph
                        :options="{
                            color: 'text-nandor',
                        }"
                    >
                        <span v-html="currentPage.content.fifthParagraph.text">
                        </span>
                        <Triangles
                            :options="{
                                colors: ['#00357f', '#0b4f9c', '#0d94ff'],
                                direction: 'bottom',
                            }"
                        />
                    </paragraph>
                     <div>
                        <image-with-descriptions
                            :options="{
                                image:
                                    'pages/' +
                                    currentPage.slug +
                                    '/' +
                                    currentPage.images.image3.src,
                                descriptions: [
                                    {
                                        text: currentPage.images.image3.edf,
                                        position: 'bottom-right', // top/bottom-left/right
                                        orientation: 'horizontal', // vertical, horizontal
                                    },
                                ],
                            }"
                        />
                    </div>
                </div>


                <div class="card break-inside-avoid">
                    <TitleParagraph
                        :options="{
                            from: 'from-resolution_blue',
                            to: 'to-dodger_blue',
                        }"
                    >
                        <span
                            class="text-xl lg:text-2xl 2xl:text-4xl"
                            v-html="currentPage.content.thirdTitle.text"
                        ></span>
                    </TitleParagraph>
                    <TitleParagraph
                        :options="{
                            from: 'from-resolution_blue',
                            to: 'to-dodger_blue',
                        }"
                    >
                        <Triangles
                            :options="{
                                colors: ['#00357f', '#0b4f9c', '#0d94ff'],
                                direction: 'bottom'
                            }"
                        />
                        <span
                            v-html="currentPage.content.sixthSubTitle.text"
                        ></span>
                    </TitleParagraph>
                    <paragraph
                        :options="{
                            color: 'text-nandor',
                        }"
                    >
                        <span
                            v-html="currentPage.content.seventhParagraph.text"
                        >
                        </span>
                    </paragraph>
                    <div>
                        <image-with-descriptions
                            :options="{
                                image:
                                    'pages/' +
                                    currentPage.slug +
                                    '/' +
                                    currentPage.images.image4.src,
                                descriptions: [
                                    {
                                        text: currentPage.images.image4.edf,
                                        position: 'bottom-right', // top/bottom-left/right
                                        orientation: 'horizontal', // vertical, horizontal
                                    },
                                ],
                            }"
                        />
                    </div>
                </div>
                
                <div class="card break-inside-avoid">
                    <TitleParagraph
                        :options="{
                            from: 'from-resolution_blue',
                            to: 'to-dodger_blue',
                        }"
                    >
                        <Triangles
                            :options="{
                                colors: ['#00357f', '#0b4f9c', '#0d94ff'],
                                direction: 'bottom',
                            }"
                        />
                        <span
                            v-html="currentPage.content.seventhSubTitle.text"
                        ></span>
                    </TitleParagraph>
                    <paragraph
                        :options="{
                            color: 'text-nandor',
                        }"
                    >
                        <span v-html="currentPage.content.eigthParagraph.text">
                        </span>
                        <!-- <square
                            :options="{
                                from: 'from-resolution_blue',
                                to: 'to-dodger_blue',
                            }"
                        /> -->
                    </paragraph>
                    <div>
                        <image-with-descriptions
                            :options="{
                                image:
                                    'pages/' +
                                    currentPage.slug +
                                    '/' +
                                    currentPage.images.image5.src,
                                descriptions: [
                                    {
                                        text: currentPage.images.image5.edf,
                                        position: 'bottom-right', // top/bottom-left/right
                                        orientation: 'horizontal', // vertical, horizontal
                                    },
                                ],
                            }"
                        />
                    </div>
                </div>

               
            </div>
        </div>
    </div>
</template>

<script>
import PagesMixin from "@/mixins/PagesMixin";
import TitleSChapter from "../../components/TitleSChapter.vue";
import Triangles from "../../components/Triangles.vue";
import TitleParagraph from "../../components/TitleParagraph.vue";
import Paragraph from "../../components/Paragraph.vue";
import ImageWithDescriptions from "../../components/ImageWithDescriptions.vue";

export default {
    components: {
        TitleSChapter,
        Triangles,
        TitleParagraph,
        ImageWithDescriptions,
        Paragraph,
    },
    name : "PageTest",
    mixins: [PagesMixin],
};
</script>

<style scoped lang="scss">
.q10__textInImage_1 {
    position: absolute;
    top: 0;
    left: 0;
    padding: 3rem;
    width: 100%;
    color: white;

    @media (max-width: 1536px) {
        top: 0vh;
        padding: 3rem;
    }
    @media (max-width: 768px) {
        top: 0;
        left: 0;
        padding: 0;
        position: relative;
        column-count: unset;
        margin-top: 1rem;
        padding: 0;
    }

    .q10__title {
        position: relative;
        width: 100%;
        top: 0;
        padding: 0;
        font-size: 4.2rem;
        color: white;
        text-align: start;
        line-height: 1;
        font-weight: bold;
        @media (max-width: 1536px) {
            top: 0vh;
        }
        @media (max-width: 1024px) {
            font-size: 3rem;
        }
        @media (max-width: 768px) {
            position: relative;
            font-size: 1.5rem;
            padding: 0;
            left: 0;
            @apply text-nandor;
        }
    }
}
.q10__textInImage_2 {
    position: absolute;

    top: 15vh;
    padding: 3rem;
    @media (max-width: 1536px) {
        top: 20vh;
        padding: 3rem;
    }
    @media (max-width: 768px) {
        top: 0;
        padding: 0;
        position: relative;
        column-count: unset;
        margin-top: 1rem;
    }
    .q10__paragraph {
        position: relative;
        font-size: 2rem;
        top: 0vh;
        height: 100px;
        color: white;
        @media (max-width: 1024px) {
            font-size: 1.5rem;
        }
        @media (max-width: 768px) {
            position: relative;
            height: 100%;
            color: black;
            margin-bottom: 2rem;
        }
    }
}

.timeline {
    column-width: 380px;
    column-gap: 40px;
    position: relative;
    margin: 5px 0;
    padding: 0;
    display: inline-block;
    width: 100%;
    height: auto;
}
</style>
